import { TranslateFunction } from '../../../../common/src/translate/TranslateFunction';

interface ITranslateProps {
    t: TranslateFunction;
}

export { ITranslateProps };
